<div [ngClass]="!actionCenter ? 'groups-container' : 'action-group-container'">
	<div class="au-filters" (click)="$event.stopPropagation()">
		<mat-form-field
			hideRequiredMarker
			class="au-search-input no-label"
			subscriptSizing="dynamic"
		>
			<input
				autocomplete="off"
				type="text"
				matInput
				placeholder="{{ 'search_user_or_team' | translate }}"
				[(ngModel)]="searchText"
			/>
			<mat-icon svgIcon="search" matSuffix class="magnifier-icon" />
		</mat-form-field>
	</div>
	<div
		[ngClass]="!actionCenter ? 'assignee-list' : 'action-assignee-list'"
		class="nice-scroll visible-scroll colored-scroll-track p-b-sm"
	>
		@if (options | assigneeQuickSearch: searchText; as foundOrganizations) {
			<div class="organization-wrapper">
				<div class="user-wrapper">
					<div
						class="user-label"
						(click)="
							selectOption($event, {
								psId: null,
								firstName: null,
								lastName: null,
								avatarUrl: '',
								contentType: 'profile',
								displayName: '',
								email: '',
								imageUrl: '',
								phoneNumber: '',
								smallAvatarUrl: '',
							})
						"
						[class.show-selection]="showSelected"
					>
						<mat-icon svgIcon="person-cancel" class="user-round-avatar" />
						<p class="user-name">{{ 'none' | translate }}</p>
						@if (showSelected && !selectedOption?.psId) {
							<span class="selected-mark">
								<mat-icon svgIcon="checkmark" />
							</span>
						}
					</div>
				</div>
				@for (organization of foundOrganizations; track organization) {
					<!--Group title-->
					<div class="organization-label" (click)="$event.stopPropagation()">
						<au-logo-placeholder [logoSrc]="organization.logoUrl" />
						<h5>{{ organization.name }}</h5>
					</div>
					@for (user of organization.users; track user.psId; let i = $index) {
						<div class="user-wrapper">
							<div
								[ngClass]="actionCenter && i === index() ? 'active' : 'inactive'"
								class="user-label"
								(click)="selectOption($event, user)"
								[class.show-selection]="showSelected"
							>
								<au-round-avatar class="user-round-avatar" [data]="user" [size]="30" />

								<p class="user-name">
									{{ user.firstName + ' ' + user.lastName }}
								</p>

								@if (showSelected && user.psId === selectedOption?.psId) {
									<span class="selected-mark">
										<mat-icon svgIcon="checkmark" />
									</span>
								}
							</div>
						</div>
					}
				}
				@if (!foundOrganizations.length) {
					<div class="no-assignees-found">
						<au-empty-placeholder
							placeholderPath="./assets/img/maskot/empty-assets.svg"
							title="{{ 'no_assignees_found' | translate }}"
						/>
					</div>
				}
			</div>
		}
	</div>
</div>
